import Alpine from 'alpinejs';

Alpine.store('modals', {
    openModals: [],

    getDialogElement(val) {
        // If already an element, return it
        if (val instanceof HTMLDialogElement) {
            return val;
        }

        // If string, assume it's an ID
        return document.getElementById(val) ?? null;
    },

    open(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        modal.showModal();
        this.openModals.push(modal);
        modal.dispatchEvent(new CustomEvent('modal:open', {
            bubbles: true,
            detail: { id: modal.id },
        }));
    },

    close(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        modal.close();
        this.openModals = this.openModals.filter(m => m !== modal);
    },

    markAsSuccess(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        modal.classList.add('is-success');

        setTimeout(() => {
            modal.classList.remove('is-success');
        }, 2500);
    },

    markAsError(modal) {
        modal = this.getDialogElement(modal);
        if (!modal) return;

        modal.classList.add('is-error');
    }
});
